<template>
  <div
    v-loading="loading"
    element-loading-text="Cargando..."
    element-loading-background="rgba(255, 255, 255)"
  >
    <el-row :gutter="40">
      <el-col :md="5">
        <el-menu default-active="1">
          <el-menu-item @click="changeTab(1)" index="1">{{ $t('Información del Contrato') }}</el-menu-item>
          <el-menu-item @click="changeTab(2)" index="2">{{ $t('Flujos de Revisión') }}</el-menu-item>
          <el-menu-item @click="changeTab(3)" index="3">{{ $t('Revisores') }}</el-menu-item>
        </el-menu>
      </el-col>
      <el-col :md="19" v-if="tab === 1 && contract" class="bordeIzquierdo">
        <el-row :gutter="20">
          <el-col :md="24">
            <div class="title">
              <b>{{$t('Nombre')}}</b>
            </div>
            {{contract.nombre}}
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :md="24" v-if="contract.tipo_contrato !== 'Propio'">
            <br />
            <div class="title">
              <b>{{$t('Estado de este Contrato')}}</b>
            </div>
            <div class="status">
              <span
                :class="['safety-tag',
                isActiveContract(contract) ? 'green' : 'red']"
              >{{ isActiveContract(contract) ? $t('Vigente') : $t('Vencido') }}</span>
            </div>
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :md="8" v-if="contract.tipo_contrato !== 'Propio'">
            <br />
            <div class="title">
              <b>{{$t('Número contrato')}}</b>
            </div>
            {{contract.numero_contrato || "Sin número de contrato"}}
          </el-col>
          <el-col :md="8" v-if="contract.tipo_contrato !== 'Propio'">
            <br />
            <div class="title">
              <b>{{$t('Fecha inicio')}}</b>
            </div>
            {{contract['fecha_inicio'] | moment("DD MMMM YYYY")}}
          </el-col>
          <el-col :md="8" v-if="contract.tipo_contrato !== 'Propio'">
            <br />
            <div class="title">
              <b>{{$t('Fecha fin')}}</b>
            </div>
            {{contract['fecha_fin'] | moment("DD MMMM YYYY")}}
            <el-button
              v-if="$store.getters.role.admin === true || $store.getters.role.role === 'owner'"
              @click="openDialogEditDateEnd()"
              class="buttonUpdate"
              size="small"
              type="primary"
            >Modificar</el-button>
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :md="contract.tipo_contrato !== 'Propio' ? 8 : 12">
            <br />
            <div class="title">
              <b>{{$t('Tipo')}}</b>
            </div>
            {{contract.tipo_contrato}}
          </el-col>
          <el-col :md="contract.tipo_contrato !== 'Propio' ? 8 : 12">
            <br />
            <div class="title">
              <b>{{$t('Area')}}</b>
            </div>
            {{getAreas(contract.area_id)}}
          </el-col>
          <el-col :md="8" v-if="contract.tipo_contrato !== 'Propio'">
            <br />
            <div class="title">
              <b>{{$t('Empresa')}}</b>
            </div>
            {{getEmpresas(contract.empresa_id)}}
          </el-col>
        </el-row>
        <br />
        <br />
        <el-row :gutter="20">
          <el-col
            :md="12"
            v-for="(val, i) in alcances"
            :key="i"
            v-if="contract.tipo_contrato !== 'Propio'"
          >
            <br />
            <div class="title">
              <b>{{val}}</b>
            </div>
            {{contract[i]}}
          </el-col>
        </el-row>
      </el-col>
      <el-col :md="19" v-if="tab === 2 && contract" class="bordeIzquierdo">
        <el-row>
          <el-col :md="24">
            <h4>Flujo de Revisión</h4>
            <br />
            <Workflow v-if="contract.workflow" :workflow="workflow" :contract="contract"/>
            <br />
          </el-col>
        </el-row>
      </el-col>
      <el-col :md="19" v-if="tab === 3 && contract" class="bordeIzquierdo">
        <el-row :gutter="10">
          <el-col :md="6" v-for="(people, profile) in contract.revisores" :key="profile">
            <div v-if="validProfile(people)" class="people">
              <span class="title">
                <b>{{ bhpProfiles[profile] }}</b>
              </span>
              <br />
              <br />
              <div v-for="(person, index) in people" :key="index">
                {{getUser(person)}}
                <br />
                <br />
              </div>
            </div>
          </el-col>
        </el-row>
        <hr />
        <el-row>
          <el-col :md="24">
            <h4>
              <span v-if="area">{{ $t('Perfiles relacionados al área') }} "{{area.nombre}}"</span>
              <span v-if="fatherArea">, {{$t('perteneciente a área')}} "{{fatherArea.nombre}}"</span>
            </h4>
          </el-col>
          <el-col :md="8">
            <div class="title">
              <b>{{$t('Superintendente de Área')}}</b>
            </div>
            <p>{{areaSuperintendente}}</p>
          </el-col>
          <el-col :md="8">
            <div class="title">
              <b>{{$t('Gerente de Área')}}</b>
            </div>
            <p>{{areaManager}}</p>
          </el-col>
          <el-col :md="8">
            <div class="title">
              <b>{{$t('Gerente de Área Superior')}}</b>
            </div>
            <p>{{areaSuperiorManager}}</p>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-dialog
      title="Modificar Fecha Fin"
      :visible.sync="dialogChangeDateEnd"
      width="30%"
      :before-close="handleClose"
    >
      <el-form :model="contractDate" ref="contractDate" label-width="200px" label-position="top">
        <el-form-item
          label="Seleccione Fecha Fin"
          prop="fechaFin"
          :rules="[
            { required: true, message: 'La final fecha es requerida'},
          ]"
        >
          <el-date-picker
            class="full-width"
            type="date"
            size="medium"
            placeholder="Ingrese Fecha Fin del Contrato"
            v-model="contractDate.fechaFin"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleClose">Cancelar</el-button>
        <el-button size="medium" type="primary" @click="submitForm('contractDate')">Modificar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Workflow from "@/components/workflows/Workflow2.vue";
import moment from "moment-timezone";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

export default {
  props: ["contract"],
  components: {
    Workflow
  },
  async created() {
    if (this.contract && Object.keys(this.contract).length) this.load();
  },
  data() {
    return {
      loading: false,
      dialogChangeDateEnd: false,
      contractDate: {
        fechaFin: ""
      },
      tab: 1,
      area_contract: null,
      fatherArea: null,
      workflow: null,
      options: [
        {
          value: "Contratista",
          label: "Contratista"
        },
        {
          value: "Propio",
          label: "Propio"
        }
      ],
      alcances: {
        alcance: "Alcance",
        alcance_trabajo: "Alcance trabajo"
      },
      bhpProfiles: {
        hse: "Asesor SSO",
        health: this.$t("Especialista de Salud"),
        safety: this.$t("Especialista de Seguridad"),
        environment: this.$t("Especialista de Medioambiente"),
        contractor_hse: this.$t("Asesor SSO Contratista"),
        owner: this.$t("Dueño de Contrato"),
        contract_owner: this.$t("Dueño de Contrato"),
        risk: this.$t("Especialista de Riesgo"),
        administrator: this.$t("Administrador de Contrato"),
        contractor_coordinator: this.$t("Coordinador Contratista"),
        coordinator: this.$t("Coordinador"),
        manager: this.$t("Gerente de Área"),
        super: this.$t("Superintendente de Área"),
        general_manager: this.$t("Gerente General")
      },
      perfiles: {
        companies: [
          "contractor_hse",
          "contractor_coordinator",
          "administrator",
          "contract_owner"
        ],
        bhp: [
          "hse",
          "health",
          "safety",
          "environment",
          "owner",
          "risk",
          "coordinator",
          "manager",
          "super",
          "general_manager"
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      empresas: "empresas",
      areasTree: "areas"
    }),
    area() {
      return this.areasTree.find(area => area._id === this.contract.area_id);
    },
    areaSuperintendente() {
      if (!this.area) return "no se encontro area";
      if (!this.area.super || !this.area.super.nombre) return "---";
      return `${this.area.super.nombre} ${this.area.super.apellido}`;
    },
    areaManager() {
      if (!this.area) return "no se encontro area";
      if (!this.area.gerente || !this.area.gerente.nombre) return "---";
      return `${this.area.gerente.nombre} ${this.area.gerente.apellido}`;
    },
    areaSuperiorManager() {
      if (!this.area) return "no se encontro area";
      if (!this.fatherArea) return "---";
      if (!this.fatherArea.gerente || !this.fatherArea.gerente.nombre) {
        return "---";
      }
      return `${this.fatherArea.gerente.nombre} ${this.fatherArea.gerente.apellido}`;
    }
  },
  watch: {
    contract: {
      handler(val, val2) {
        if (val && Object.keys(val).length) this.load();
      }
    }
  },
  methods: {
    ...mapActions(["getContractsFaena"]),
    async load() {
      this.loading = true;
      this.contractDate.fechaFin = this.contract.fecha_fin;
      await this.getContractArea(this.contract.area_id);
      if (this.area_contract && this.area_contract.area_padre_id) {
        await this.getContractFatherArea(this.area_contract.area_padre_id);
      }
      this.workflow = await this.getWorkflow(this.contract.workflow);
      this.loading = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveEdit();
          this.handleClose();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeTab(tab) {
      this.tab = tab;
    },
    getAreas(id) {
      try {
        const area = this.areasTree.find(x => x._id === id);
        return area ? area.nombre : "";
      } catch (error) {
        console.log(error);
      }
    },
    getEmpresas(id) {
      try {
        const empresa = this.empresas.find(x => x._id === id);
        return empresa ? empresa.nombre : "";
      } catch (error) {
        console.log(error);
      }
    },
    async getWorkflow(id) {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      };
      const response = await axios.get(`workflow/${id}`, config);
      return response.data;
    },
    async getContractArea(id) {
      this.area_contract = await this.getArea(id);
    },
    async getContractFatherArea(id) {
      this.fatherArea = await this.getArea(id);
    },
    async getArea(id) {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      };
      const response = await axios.get(`areas/${id}`, config);
      return response.data;
    },
    getUser(id) {
      let findUser = "";
      this.$store.getters.usersFaena.forEach(user => {
        if (user._id === id) {
          findUser = `${user.nombre} ${user.apellido}`;
        }
      });
      return findUser;
    },
    validProfile(profile) {
      for (let i = 0; i < profile.length; i++) {
        if (profile[i] === "") {
          return false;
        }
        return true;
      }
    },
    isActiveContract(contract) {
      return moment(contract.fecha_fin) - new Date() >= 0;
    },
    handleClose() {
      this.dialogChangeDateEnd = false;
    },
    openDialogEditDateEnd() {
      this.dialogChangeDateEnd = true;
    },
    saveEdit() {
      const id = this.contract._id;
      const fecha = {
        fecha_fin: this.contractDate.fechaFin
      };
      this.$store
        .dispatch("editContractSpecificField", {
          id,
          body: fecha
        })
        .then(async response => {
          if (response.success) {
            this.getContractsFaena();
            const newContract = JSON.parse(JSON.stringify(this.contract));
            newContract.fecha_fin = this.contractDate.fechaFin;
            this.$store.dispatch("setActualContract", newContract);
            /* this.contract['fecha_fin'] = this.contractDate.fechaFin; */
            this.$notify.success({
              title: this.$t("Éxito"),
              message: this.$t("Contrato editado exitosamente")
            });
          } else {
            this.$alert(response.message, this.$t("Atención"), {
              type:
                "error" /* this.contract['fecha_fin'] = this.contractDate.fechaFin; */
            });
          }
        });
    }
  }
};
</script>

<style scoped>
.bordeIzquierdo {
  border-left: 1px solid black;
}

.title {
  color: rgb(7, 116, 141);
  padding-bottom: 10px;
}

.el-menu {
  border-right: none;
}

.status {
  padding-top: 8px;
  padding-bottom: 4px;
}

.people {
  min-height: 140px;
}

.buttonUpdate {
  margin-left: 10px;
}
</style>
